import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import Dialog from '@mui/material/Dialog';
import React, { useEffect } from 'react';
import { create } from 'zustand';
import { PriceDialogContent } from '../../Components/BuyBoxDialog/PriceDialogContent.js';
import { hexadecimal } from '../../utils/stringUtils.js';

var useBuyBoxDialogStore = create(function (set) { return ({
    open: false,
    close: function () { return set({ open: false }); },
    products: [],
    onClick: function () { return void null; },
    onProductPageClick: function () { return void null; },
}); });
var BuyBoxDialog = function () {
    var state = useBuyBoxDialogStore();
    var open = state.open, close = state.close, products = state.products, onClick = state.onClick, onProductPageClick = state.onProductPageClick;
    useEffect(function () {
        var _a;
        (_a = state.listener) === null || _a === void 0 ? void 0 : _a.call(state, state);
    }, [state]);
    React.useEffect(function () {
        close();
        // close the dialog whenever the location changes
    }, [window.location.pathname]);
    return (React.createElement(Dialog, { open: open, onClose: close, sx: {
            zIndex: 1400,
            '& div.MuiDialog-paper': {
                margin: '0 20px',
                width: '100%',
                maxWidth: 625,
            },
        }, slotProps: {
            backdrop: {
                sx: function (theme) { return ({ backgroundColor: hexadecimal(theme.palette.primary.main)(21) }); },
            },
        } },
        React.createElement(PriceDialogContent, { onClose: close, productsToList: products, onBuyClick: onClick, onOpenRetailerProductPageClick: onProductPageClick })));
};
BuyBoxDialog.show = function (props) {
    useBuyBoxDialogStore.setState(__assign(__assign({}, props), { open: true }));
};
BuyBoxDialog.hide = function () {
    useBuyBoxDialogStore.setState({
        open: false,
    });
};

export { BuyBoxDialog };
//# sourceMappingURL=index.js.map
